<template lang="html">
  <b-card>
    <div slot="header">
      Verificações
    </div>
    <div class="row" v-if="verifications">
      <div class="col-sm-6">
        <strong>Link</strong>
      </div>
      <div class="col-sm-2">
      </div>
      <div class="col-sm-4">
        <strong>Data Expiração</strong>
      </div>
    </div>
    <div class="row" v-for="v in verifications"  v-bind:key="v.id">
      <div class="col-sm-6">
        <input type="text" readonly class="form-control-plaintext" :value="v.link">
      </div>
      <div class="col-sm-2">
        <button-component :href="v.whatsappLink" target="_blank" class="btn btn-outline-success"><i class="micon-whatsapp"></i></button-component>
      </div>
      <div class="col-sm-4">
        <div class="form-control-plaintext">{{ v.expiration | moment-complete}}</div>
      </div>
    </div>
    <b-row>
    <button-component
      label="Criar nova verificação"
      classes="btn-primary btn-facebook"
      :nolink="true"
      @click.native="createVerification"
    />
    <div class="text-danger">{{ msgErro }}</div>
    <button-component
      label="Atualizar lista"
      classes="btn-outline-secondary ml-2"
      :nolink="true"
      @click.native="listVerifications"
    />
    </b-row>
  </b-card>
</template>
<script>
import Button from '../../../partial/button/Button.vue'

export default {
  components: {
    'button-component': Button
  },
  data () {
    return {
      msgErro: '',
      // url: '',
      verifications: null
    }
  },
  props: [],
  methods: {
    createVerification () {
      this.$http.post('api/validations/' + this.$route.params.txid)
        .then(function (res) {
          // this.url = res.data.url
          this.listVerifications()
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.msgErro = res.data
        })
    },
    listVerifications () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/files')
        .then(function (res) {
          this.verifications = res.data.list
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.msgErro = res.data
        })
    }
  },
  mounted () {
    this.listVerifications()
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/partial/cards/verification/VerificationDetails.vue